import CanPlayStatus from '@apptypes/api/user/CanPlayStatus.ts';
import LoadingButton from '@components/LoadingButton.tsx';
import { useAuth } from '@hooks/useAuth.tsx';
import { useI18n } from '@hooks/useI18n.tsx';
import { setLogout } from '@state/reducers/user.ts';
import GenericModal from '@v2/components/modals/GenericModal.tsx';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';

export const SelfExcludedCheck = () => {
  const { t, jsxT } = useI18n();
  const { user, signout, updateUser } = useAuth();
  const [showModal, setShowModal] = useState<boolean>(false);
  const history = useHistory();
  const dispatch = useDispatch();
  const doLogout = () => {
    signout().then(() => {
      dispatch(setLogout());
      setShowModal(false);
      history.push('/');
    });
  };

  useEffect(() => {
    if (!user?.can_play) {
      setShowModal(false);
      return;
    }
    if (
      user?.can_play === CanPlayStatus.SelfExcluded &&
      window.__config__.componentSettings?.logoutOnSelfExcludedStatus
    ) {
      setShowModal(true);
    }
  }, [user?.can_play]);

  return (
    <GenericModal
      isCentered
      show={showModal}
      withoutClose={true}
      preventEscClose={true}
      preventBluringClose={true}
      hideCallback={() => {
        doLogout();
        setShowModal(false);
      }}
      className="pb-5"
    >
      <h2 className="mb-2">{t('player_disable_modal_title')}</h2>
      <p className="mb-3">{jsxT(`player_disable_modal_desc`)}</p>
      <div className="d-flex justify-content-end gap-2 mt-5">
        <LoadingButton
          className="w-30"
          variant="primary"
          onClick={() => {
            doLogout();
          }}
        >
          {'Ok'}
        </LoadingButton>
      </div>
    </GenericModal>
  );
};
